<template>
    <div id="app" class="flex flex-col">
        <preloader v-if="loading"/>
        <template v-if="user">
            <app-header/>
            <div 
                class="relative flex-1"
                :class="{'overflow-hidden': overflowHidden}" 
                style="margin-top: 48px;"
            >
                <left-side v-show="this.$store.state.leftOpen"></left-side>
                <right-side>
                    <router-view />
                </right-side>
            </div>

            <div class="background-overlay" @click="right_close"></div>
        </template>
        <router-view v-else />
        <component 
            :is="modal.component" 
            :path="modal.path" 
            :show="showModal"
            :route="modal.route"
            @close="closeModal"
        />
        <app-modal
            :show.sync="showOTPModal"
            width="lg:w-1/4"
        >
            <template slot="header">One Time Password</template>
            <template slot="body">
                <app-input type="text"
                    v-model="otpForm.one_time_password"
                    focus
                    placeholder="One Time Password"
                    :error="otpForm.errors.get('one_time_password')"
                    @updated="otpForm.errors.clear('one_time_password')"
                    @keyup.enter.native="checkOTP"
                ></app-input>
                <div class="flex items-center justify-end mt-5">
                    <app-button 
                        class="btn-blue ml-2"
                        :loading="otpLoading"
                        @click="checkOTP"
                    >Submit</app-button>
                </div>
            </template>
        </app-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';
    import Http from '@/helpers/Http';

    export default {
        name: 'layout',
        components: {
            Preloader: () =>
                import ( /*webpackChunkName: "preloader"*/ '@/components/layouts/preloader/bounce'),
            AppHeader: () => import ( /*webpackChunkName: "app-header"*/ '@/components/layouts/header/fixed-header'),
            LeftSide: () => import ( /*webpackChunkName: "left-side"*/ '@/components/layouts/left-side/default/left-side'),
            RightSide: () => import ( /*webpackChunkName: "right-side"*/ '@/components/layouts/right-side')
        },
        data() {
            return {
                showtopbtn: false,
                overflowHidden: true,
                otpLoading: false,
                otpForm: new Form({
                    one_time_password: null,
                }),
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user',
                showOTPModal: 'auth/showOTPModal',
                modal: 'modal',
                showModal: 'showModal',
                loading: 'loading',
            })
        },
        watch: {
            $route() {
                this.overflowHidden = true;

                if (window.innerWidth <= 992) {
                    this.$store.commit('left_menu', 'close')
                }

                if (['dashboard', 'settings'].includes(this.$route.name)) {
                    this.overflowHidden = false;
                }
            }
        },
        mounted() {
            if (window.innerWidth <= 992) {
                this.$store.commit('left_menu', 'close')
            }
        },
        created() {
            window.addEventListener('resize', (e) => {
                if (window.innerWidth <= 992) {
                    this.$store.commit('left_menu', 'close')
                }
            });

            document.addEventListener(
                'swUpdated', this.refreshApp, { once: true }
            );

            navigator.serviceWorker.addEventListener(
            'controllerchange', () => {
                    window.location.reload();
                }
            );
        },
        methods: {
            right_close() {
                this.$store.commit('rightside_bar', "close");
            },
            refreshApp (e) {
                if (!e.detail || !e.detail.waiting) { return; }
                e.detail.waiting.postMessage('skipWaiting');
            },
            closeModal() {
                this.$store.commit('setShowModal', false);
            },
            checkOTP() {
                this.otpLoading = true;
                this.otpForm.errors.clear();
                Http.post('otp/check', this.otpForm.payload())
                    .then(({data}) => {
                        this.otpLoading = false;
                        this.otpForm.reset();
                        this.$store.commit('auth/toggleOTPModal');
                        this.$router.push({ name: 'dashboard' });
                    })
                    .catch(({ response }) => {
                        this.otpLoading = false;
                        this.otpForm.errors.record(response.data);
                    });
            }
        },
    }
</script>